import { ResultSet } from "@cubejs-client/core";
import { immerable } from "immer";

import { AppThunk } from "appThunk";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";
import { PlaceCategory } from "modules/customer/insights/portfolioNew/placeCategory";


export class CompetitorStoreCategory extends PlaceCategory {
    [immerable] = true;

    public readonly isPrimary: boolean;
    private _isSelected: boolean;

    constructor(
        placeCategory: PlaceCategory,
        isPrimary: boolean,
        _isSelected: boolean
    ) {
        super(
            placeCategory.id,
            placeCategory.name,
            placeCategory.superCategoryName,
            placeCategory.indirectlyCompetingCategories,
            placeCategory.isDestination,
            placeCategory.isRetailer
        );
        this.isPrimary = isPrimary;
        this._isSelected = _isSelected;
    }

    isSelected() {
        return this._isSelected;
    }

    setIsSelected(isSelected: boolean) {
        this._isSelected = isSelected;
    }

    toggleIsSelected() {
        this._isSelected = !this._isSelected;
    }

    getLabel(): string {
        return `${this.name} (${this.isPrimary ? "Primary" : "Secondary"} category)`;
    }
}

export const loadPlaceCategories = (): AppThunk<Promise<PlaceCategory[]>> => async (dispatch) => {
    try {
        const query = {
            dimensions: [
                "PlaceCategory.PlaceCategoryID",
                "PlaceCategory.PlaceCategoryName",
                "PlaceCategory.SuperCategoryName",
                "PlaceCategory.CompetingCategoryIds",
                "PlaceCategory.IsDestination",
                "PlaceCategory.IsRetailer"
            ]
        };
        const resultSet = await dispatch(cubeLoad(query)) as unknown as ResultSet;
        const placeCategories = resultSet.rawData().map(item =>
            new PlaceCategory(
                Number(item["PlaceCategory.PlaceCategoryID"]),
                String(item["PlaceCategory.PlaceCategoryName"]),
                String(item["PlaceCategory.SuperCategoryName"]),
                JSON.parse((item["PlaceCategory.CompetingCategoryIds"]) ?? "[]"),
                Boolean(item["PlaceCategory.IsDestination"]),
                Boolean(item["PlaceCategory.IsRetailer"])
            )
        );
        return placeCategories;
    } catch (error) {
        dispatch(logError("Error loading ProductCategories.", error));
        throw error;
    }
};
